import { render, staticRenderFns } from "./VehicleRegistry.vue?vue&type=template&id=5605dfea&"
import script from "./VehicleRegistry.vue?vue&type=script&lang=js&"
export * from "./VehicleRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports